import React from "react";
import "../styles/easyon-product.css";
import { EasyonHeroSection } from "../components/easyon/EasyonHeroSection";
import { EasyonPlatformsSection } from "../components/easyon/EasyonPlatformsSection";
import { EasyonDashboardSection } from "../components/easyon/EasyonDashboardSection";
import { EasyonDatabaseSection } from "../components/easyon/EasyonDatabaseSection";
import { EasyonInventorySection } from "../components/easyon/EasyonInventorySection";
import { EasyonAiShowcaseSection } from "../components/easyon/EasyonAiShowcaseSection";
import { EasyonWorkflowSection } from "../components/easyon/EasyonWorkflowSection";
import { EasyonComplianceTimelineSection } from "../components/easyon/EasyonComplianceTimelineSection";
import { EasyonIndustryCarouselSection } from "../components/easyon/EasyonIndustryCarouselSection";
import { EasyonBusinessImpactSection } from "../components/easyon/EasyonBusinessImpactSection";
import { EasyonFaqSection } from "../components/easyon/EasyonFaqSection";
import { EasyonFinalCtaSection } from "../components/easyon/EasyonFinalCtaSection";

export const EasyOnPage = () => (
    <div className="eo-product-page">
        <EasyonHeroSection />
        <EasyonAiShowcaseSection />
        <EasyonPlatformsSection />
        <EasyonDashboardSection />
        <EasyonWorkflowSection />
        <EasyonInventorySection />
        <EasyonDatabaseSection />
        <EasyonComplianceTimelineSection />
        <EasyonIndustryCarouselSection />
        <EasyonBusinessImpactSection />
        <EasyonFaqSection />
        <EasyonFinalCtaSection />
    </div>
);
